import View from "layouts/tickets/View";
import Manage from "layouts/tickets/ManageTickets";
import ProtectedRoute from "./ProtectedRoute";

const TicketRoutes = [

  {
    route: "/tickets/view/:id",
    key: "view-tickets",
    component: <ProtectedRoute check="logout"><View /></ProtectedRoute>
  },
  {
    route: "/tickets/list/:pageNo",
    key: "manage-ticket",
    component: <ProtectedRoute check="logout"><Manage /></ProtectedRoute>
  }
];

export default TicketRoutes;
